export function isReprocesingAvailable(updateAt: string): boolean {
  const fiveMinutesInMs = 5 * 60 * 1000;
  let now = Date.now();
  let updatedAt = new Date(updateAt).getTime();
  const differenceInMs = now - updatedAt;
  return differenceInMs > fiveMinutesInMs;
}
